import { render, staticRenderFns } from "./ArchivePaymentsModal2.vue?vue&type=template&id=5c98511d&"
import script from "./ArchivePaymentsModal2.vue?vue&type=script&lang=js&"
export * from "./ArchivePaymentsModal2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchivePaymentsModal2.vue"
export default component.exports